import React from "react";
import styles from "../../../styles/component-styles/general/grid.module.scss";
import no_data from "../../../assets/images/no_data.svg";
import { useSelector } from "react-redux";
import { selectLanguage } from "../../../redux/slice/language/laguage.slice";
import { constants } from "../../../constants";
import { useState, useEffect } from "react";
import { WatchVideo } from "../../admin/modals/watchVideo";
import { useSearchParams } from "react-router-dom";
import { VideoPlayer } from "../../admin/modals/VideoPlayerSimple";
import { BASE_URL } from "../../../utils/constants";

export function Grid({
  isAdmin,
  searchTerm
}) {
  const language = useSelector(selectLanguage);
  const [searchParams, setSearchParams] = useSearchParams();
  const [newVideos, setNewVideos] = useState([]);
  const [selectedNewVideo, setSelectedNewVideo] = useState(null);

  const fetchAllVideos = async () => {
    const API_URL = `${BASE_URL}/all_videos`;

    try {
      const res = await fetch(API_URL, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });

      if (!res.ok) {
        throw new Error("Network response was not ok " + res.statusText);
      }

      const data = await res.json();
      setNewVideos(data.videos);
    } catch (error) {
      console.error("Error fetching videos:", error);
      throw error;
    }
  };

  useEffect(() => {
    fetchAllVideos();
  }, []);

  const onClick = (video) => {
    setSelectedNewVideo(video);
  };

  const onClose = () => {
    setSearchParams({});
    setSelectedNewVideo(null);
  };


  return (
    <React.Fragment>
      <div className={styles.grid}>
        <WatchVideo
          isOpen={searchParams.get("videoId") != null}
          videoId={searchParams.get("videoId")}
          onClose={onClose}
          isAdmin={isAdmin}
        />

      </div>
      <div className="new_videoThumbnails">
        {newVideos && newVideos.length > 0 ? (
          <div className="new_gridContainer">
            {newVideos
              .filter((video) =>
                video.decodedName
                  .toLowerCase()
                  .includes(searchTerm.toLowerCase())
              )
              .map((video) => (
                <div
                  key={video.name}
                  className="new_videoThumbnail"
                  onClick={() => onClick(video)}
                >
                  <img
                    src={video.thumbnailUrl}
                    alt={video.decodedName}
                    className="new_thumbnail"
                  />
                  <p className="new_videoTitle">
                    <div>{video.decodedName.split("-")[0]}</div>

                    {video.decodedName.split("-")[1]}
                  </p>
                </div>
              ))}
          </div>
        ) : (

            <div className={styles.noData}>
            <img src={no_data} />
            <p>{constants[language].no_data}</p>
          </div>
        )}

        {selectedNewVideo && (
          <VideoPlayer
            isAdmin={isAdmin}
            videoName={selectedNewVideo.name}
            videoUrl={selectedNewVideo.url}
            isOpen={selectedNewVideo.url}
            onClose={onClose}
          />
        )}
      </div>
    </React.Fragment>
  );
}
